// extracted by mini-css-extract-plugin
export var createdDate = "_m3-1";
export var divider = "_m3-2";
export var headerDivider = "_m3-3";
export var messagesCard = "_m3-0";
export var messagesContainer = "_m3-6";
export var messagesContainerWrapper = "_m3-4";
export var showLeftPanelButton = "_m3-8";
export var topButtons = "_m3-7";
export var withPadding = "_m3-5";